// Import/export de archivos de torneo (KTS, Challonge, TopDeck).

import { gql } from 'graphql-request';
import { getGraphQLQueryClient } from '../query-client';
import axiosClient from '../request-client';
import { AxiosRequestConfig } from 'axios';
import {
  Nullable,
  Tournament,
  UserWithToken,
  WithMeta,
} from '../api.types';

export const lastTournaments = async (
  user: Nullable<UserWithToken>,
  filters: Record<string, unknown>
) =>
  getGraphQLQueryClient(user).request<WithMeta<Tournament>>(
    gql`
      query lastTournaments($filters: TournamentFilters) {
        data: lastTournaments(filters: $filters) {
          data {
            id
            title
            status
            dateFrom
            dateTo
            totalPlayers
            rounds
            currentRound
            tournamentType

            players {
              id
              status
              deckName
              user {
                id
                cossyId
              }
            }

            results {
              id
              userId
              position
              points
              wins
              losses
              draws
            }

            location {
              name
              address
            }

            withTop

            topTournaments {
              id
              status
            }

            organizer {
              id
              name
              logoUrl
            }

            format {
              id
              name
            }
          }
          meta {
            total
            perPage
            lastPage
          }
        }
      }
    `,
    { filters }
  );

export const importTournamentFile = (
  body: FormData,
  config?: AxiosRequestConfig
) =>
  axiosClient.post(`/imports/tournament-file`, body, {
    ...config,
    headers: {
      ...config?.headers,
      'Content-Type': 'multipart/form-data',
    },
  });

export const importFromChallonge = (
  url: string,
  tournamentId: number,
  config?: AxiosRequestConfig
) =>
  axiosClient.post(
    `/imports/tournament-challonge`,
    { url, tournamentId },
    config
  );

export const importFromTopdeck = (
  url: string,
  tournamentId: number,
  config?: AxiosRequestConfig
) =>
  axiosClient.post(
    `/imports/tournament-topdeck`,
    { url, tournamentId },
    config
  );

export const uploadTournamentFile = (
  tournamentId: number,
  file: File,
  config?: AxiosRequestConfig
) => {
  const formData = new FormData();
  formData.append('file', file);

  return axiosClient.post(`/tournaments/${tournamentId}/files`, formData, {
    ...config,
    headers: {
      ...config?.headers,
      'Content-Type': 'multipart/form-data',
    },
  });
};

export const deleteTournamentFile = (
  tournamentId: number,
  fileId: number,
  config?: AxiosRequestConfig
) => axiosClient.delete(`/tournaments/${tournamentId}/files/${fileId}`, config);

export const downloadTournamentFile = (
  tournamentId: number,
  fileId: number,
  config?: AxiosRequestConfig
) =>
  axiosClient.get(`/tournaments/${tournamentId}/files/${fileId}`, {
    ...config,
    responseType: 'blob',
  });
